import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AppConfig } from 'src/app/app.config';
import { switchMap, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
  departmentSvcUrl: string;
  private dataCache: { [key: string]: Observable<any> } = {};
  constructor(private http: HttpClient, private config: AppConfig) {
    this.departmentSvcUrl = this.config.apiUrl + "MasterDataApi";
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  getDepartments() {
    return this.http.get(this.departmentSvcUrl + "/" + "GetDepartments").pipe(
      catchError(this.handleError)
    );
  }
  getMasterGroupByCategory(category) {
    return this.http.get(this.departmentSvcUrl + "/" + "GetMasterGroupByCategory?category=" + category).pipe(
      catchError(this.handleError)
    );
  }
  getMasterGroupByGroupID(groupID) {
    return this.http.get(this.departmentSvcUrl + "/" + "GetMasterGroupByGroupID?GroupID=" + groupID).pipe(
      catchError(this.handleError)
    );
  }

  fetchAndCacheEeTypeList(category: string): Observable<any> {
    if (this.dataCache[category]) {
      return this.dataCache[category];
    }

    const fetchObservable = this.getMasterGroupByCategory(category).pipe(
      switchMap((data: any[]) => {
        if (data != null && data.length > 0) {
          const groupID = data[0].ID;

          if (groupID) {
            return this.getMasterGroupByGroupID(groupID);
          } else {
            throw new Error('Group ID not found');
          }
        }
      }),
      catchError((error) => {
        console.error('Error fetching data:', error);
        throw error;
      }),
      shareReplay(1)
    );

    this.dataCache[category] = fetchObservable;

    return fetchObservable;
  }
}
